import { useMemo, useRef } from 'react';
import { useUnmount } from 'ahooks';
import { SVGPureIcon } from '@/ui';
import globalStore from '@/store/global';
import { observer } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';

function KnowledgeCard(props) {
  const { info, count, closeable, onClose } = props;

  if(count > 0){
    return (
      <div className="flex items-center gap-[8px]">
        <section
          className={[
            'relative',
            'group',
            'w-[176px]',
            'rounded-[12px] border',
            'py-[8px] px-[10px]',
            'flex gap-[8px]',
            'text-[12px] leading-snug',
            'border-[rgba(0,0,0,.1)]'
          ]}
        >
          <div className="size-32px rounded-full flex items-center justify-center bg-[#F0F0F0]">
            <SVGPureIcon name="more" />
          </div>
          <section className="flex flex-col overflow-hidden">
            <span className="text-primary-opacity text-opacity-80 font-bold truncate">更多知识库</span>
            <span className="text-primary-opacity text-opacity-50">
              已隐藏{count}个
            </span>
          </section>
        </section>
      </div>
    )
  }

  return (
    <div className="flex items-center gap-[8px]">
      <section
        className={[
          'relative',
          'group',
          'w-[176px]',
          'rounded-[12px] border',
          'py-[8px] px-[10px]',
          'flex gap-[8px]',
          'text-[12px] leading-snug',
          closeable ? 'hover:bg-[rgba(0,0,0,.03)]' : '',
          globalStore.isDark ? 'border-[rgba(255,255,255,.3)]' : 'border-[rgba(0,0,0,.1)]'
        ]}
      >
        <img className="size-32px rounded-8px" src="https://p0.ssl.qhimg.com/t11098f6bcdc75af6de773b647f.png" />
        <section className="flex flex-col overflow-hidden">
          <span className="text-primary-opacity text-opacity-80 font-bold truncate">{info.name}</span>
          <span className="text-primary-opacity text-opacity-50">
            {info.total || info.count_files}个内容  {info.total_size ? HelperCore.getFixedTextSize(info.total_size, 0) : ''}
          </span>
        </section>

        <span
          className={[
            'absolute -top-[7px] -right-[7px] z-100',
            'rounded-full p-[6px]',
            'bg-black bg-opacity-70 hover:bg-opacity-80',
            'cursor-pointer',
            'hidden',
            { 'group-hover:inline': closeable },
          ]}
          onClick={() => onClose?.(info)}
        >
          <SVGPureIcon name="close-8" className="size-8px text-white" />
        </span>
      </section>
    </div>
  );
}

export default observer(KnowledgeCard);
